import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import ChaptersListPage from "./pages/ChaptersListPage";
import ChapterPage from "./pages/ChapterPage";
import BookmarksPage from "./pages/BookmarksPage";
import MainLayout from "./components/common/MainLayout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import AdminRoute from "./components/common/AdminRoute";
import FavoritesPage from "./pages/FavoritesPage";
import OfflineChaptersPage from "./pages/OfflineChaptersPage"; 
import EndingSuggestionPage from "./pages/EndingSuggestionPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUserManagement from "./pages/admin/AdminUserManagement";
import AdminStoryManagement from "./pages/admin/AdminStoryManagement";
import AdminStoryDetail from "./pages/admin/AdminStoryDetail";
import ChapterDetailEdit from "./pages/admin/ChapterDetailEdit";
import AdminCategoryManagement from "./pages/admin/AdminCategoryManagement";
import { useTranslation } from 'react-i18next';

const App = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Router>
      <div>
        <select onChange={(e) => changeLanguage(e.target.value)} defaultValue="vi">
          <option value="vi">Tiếng Việt</option>
          <option value="en">English</option>
          <option value="fr">Français</option>
        </select>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            {/* Nested Routes under MainLayout */}
            <Route index element={<HomePage />} />
            <Route path="stories" element={<HomePage />} />
            <Route path="bookmarks" element={<BookmarksPage />} />
            <Route path="favorites" element={<FavoritesPage />} />
            <Route path="stories/:id" element={<ChaptersListPage />} />
            <Route path="stories/:id/chapters" element={<ChaptersListPage />} />
            <Route path="stories/:id/chapters/:chapter_id" element={<ChapterPage />} />
            <Route path="/offline-chapters" element={<OfflineChaptersPage />} />
            <Route path="/chapters/:chapter_id/offline" element={<ChapterPage />} />
            <Route path="/suggest-ending" element={<EndingSuggestionPage />} />
          </Route>

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <MainLayout />
              </AdminRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUserManagement />} />
            <Route path="stories" element={<AdminStoryManagement />} />
            <Route path="stories/:id/detail" element={<AdminStoryDetail />} />
            <Route path="/admin/chapters/:chapterId/edit" element={<ChapterDetailEdit />} />
            <Route path="/admin/categories" element={<AdminCategoryManagement />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;
